import { ElementRef } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { CUSTOMIZE_PAGES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "NewAngular/services/dropdown-helper.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i5 from "@angular/forms";
const _c0 = a0 => ({ show: a0 });
function FormatMenuComponent_div_0_label_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 6)(1, "input", 7);
    i0.ɵɵlistener("change", function FormatMenuComponent_div_0_label_4_Template_input_change_1_listener() { const listItem_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.updateSelectedFormat(listItem_r4.value)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 8)(3, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngModel", listItem_r4.selected)("disabled", listItem_r4.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", listItem_r4.label);
} }
function FormatMenuComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "a", 2);
    i0.ɵɵlistener("click", function FormatMenuComponent_div_0_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.isOpen = !ctx_r1.isOpen); });
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, FormatMenuComponent_div_0_label_4_Template, 4, 3, "label", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r1.isOpen));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.selectedFormat);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.isOpen));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.configCopy);
} }
export class FormatMenuComponent {
    constructor(accountsService, dropdownHelperService, el) {
        this.accountsService = accountsService;
        this.dropdownHelperService = dropdownHelperService;
        this.el = el;
        this.USER = window.USER;
    }
    ngOnInit() {
        this.isOpen = false;
        this.configCopy = cloneDeep(this.config);
        this.updateSelectedFormat(this.format);
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.isOpen = false;
            }
        };
        this.dropdownHelperService.setCloseHandler(this.el.nativeElement, autoCloseHandler);
    }
    updateSelectedFormat(selected) {
        if (this.USER.authenticated) {
            this.configCopy.forEach((listItem) => {
                // eslint-disable-next-line no-param-reassign
                listItem.selected = listItem.value === selected;
            });
            const item = this.config.find((_) => _.value === selected);
            if (item) {
                this.selectedFormat = item.label;
            }
            this.accountsService.putUserPreferences({ [this.userPreferenceName]: selected }).subscribe(() => {
                if (selected !== this.format) {
                    window.location.reload();
                }
            });
        }
        else {
            const item = this.configCopy.find((_) => _.selected);
            if (item) {
                item.selected = false;
            }
            this.configCopy[0].selected = true;
            this.selectedFormat = this.configCopy[0].label;
            if (this.featureNeededComponent) {
                this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
            }
        }
    }
}
FormatMenuComponent.ɵfac = function FormatMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormatMenuComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.DropdownHelperService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
FormatMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormatMenuComponent, selectors: [["ycn-format-menu"]], viewQuery: function FormatMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { format: "format", userPreferenceName: "userPreferenceName", config: "config" }, standalone: false, decls: 2, vars: 1, consts: [["class", "dropdown min-width-20", 3, "ngClass", 4, "ngIf"], [1, "dropdown", "min-width-20", 3, "ngClass"], ["role", "button", "href", "javascript:void(0)", 1, "btn", "btn-block", "btn-secondary", "dropdown-toggle", 3, "click"], [1, "text-default", 3, "textContent"], [1, "dropdown-menu", 3, "ngClass"], ["class", "custom-control custom-checkbox dropdown-item custom-checkbox-style1", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModel", "disabled"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"]], template: function FormatMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FormatMenuComponent_div_0_Template, 5, 8, "div", 0);
        i0.ɵɵelement(1, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.format);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.FeatureNeededComponent, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.NgModel], encapsulation: 2 });
